export default __webpack_public_path__ + "d8546d3810db80f9ffe99f7db67b421f.woff2";